import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { CommentAnnotation } from 'app/modules/comments/types';

interface AnnotationInteractionContextValue {
  onAnnotationClick: (annotation: CommentAnnotation) => void;
  activeAnnotationText: string | null;
}

const AnnotationInteractionContext =
  createContext<AnnotationInteractionContextValue | null>(null);

interface ProviderProps {
  children: ReactNode;
  onAnnotationClick: (annotation: CommentAnnotation) => void;
  activeAnnotationText: string | null;
}

export const AnnotationInteractionProvider: FC<ProviderProps> = ({
  children,
  onAnnotationClick,
  activeAnnotationText,
}) => {
  const value = useMemo(
    () => ({ onAnnotationClick, activeAnnotationText }),
    [onAnnotationClick, activeAnnotationText],
  );

  return (
    <AnnotationInteractionContext.Provider value={value}>
      {children}
    </AnnotationInteractionContext.Provider>
  );
};

export const useAnnotationInteraction = () => {
  return useContext(AnnotationInteractionContext);
};
